export default {
  // 系统基础请求，成功
  'REQUESTSUCESS': {
    code: '200',
    message: '请求成功'
  },
  'ZIGUANREQUESTSUCESS': {
    code: '9999',
    message: '资管请求成功'
  },
  'LOGINSUCCESS': {
    code: '610',
    message: '请求成功'
  },
  'REQUESTFAIL': {
    code: '606',
    message: '请求失败，没有获取到登录态'
  },
  'LOGINFAIL': {
    code: '903',
    message: '请求失败，没有获取到登录态'
  },

  errorCode: {
    // 版本升级相关
    '812': '新增的版本不能比历史版本号低',
    // 会议相关内容
    '3601': '该会议室已被预订/锁定，不能再次锁定',
    '3602': '未找到会议室负责人',
    '3603': '无会议审批权限',
    '3604': '订单不存在或已取消',
    '3605': '还有未处理的订单',
    '3606': '不能选择已过去时间',
    //
    // 企业检查用户
    '607': '该用户已经是管理员',
    '605': '用户不存在',
    '6010': '用户不属于该企业',
    '60201': '该用户未注册',
    '60202': '企业已经存在管理员',
    '60203': '该用户已经是管理员'
  }
}



// WEBPACK FOOTER //
// ./src/area-base/utils/requestResponse.js